<template>
	<div class="tab-text">
		<h3 class="mb-4">Cruise Itinerary</h3>

		<div class="w-full flex flex-wrap">
			<div class="w-full lg:w-1/2 sm:w-1/1 pr-4">
            
            <vs-table stripe class="tabletable">
                <template slot="thead">
                    <vs-th>Day</vs-th>
                    <vs-th>Port</vs-th>
                    <vs-th>Arrival</vs-th>
                    <vs-th>Departure</vs-th>
                </template>
                <template>
                    <vs-tr>
                        <vs-td>
                            0
                        </vs-td>
                        <vs-td>
                        Whittier, Alaska
                        </vs-td>
                        <vs-td>
                        </vs-td>
                        <vs-td>
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            1
                        </vs-td>
                        <vs-td>
                        Hubbard Glacier
                        </vs-td>
                        <vs-td>
                        15:00
                        </vs-td>
                        <vs-td>
                        20:00
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            2
                        </vs-td>
                        <vs-td>
                        Glacier Bay
                        </vs-td>
                        <vs-td>
                        9:15
                        </vs-td>
                        <vs-td>
                        19:30
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            3
                        </vs-td>
                        <vs-td>
                        Skagway
                        </vs-td>
                        <vs-td>
                        7:00
                        </vs-td>
                        <vs-td>
                        20:30
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            4
                        </vs-td>
                        <vs-td>
                        Juneau, Alaska
                        </vs-td>
                        <vs-td>
                        6:30
                        </vs-td>
                        <vs-td>
                        17:00
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            5
                        </vs-td>
                        <vs-td>
                        Ketchikan
                        </vs-td>
                        <vs-td>
                        10:00
                        </vs-td>
                        <vs-td>
                        18:00
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            6
                        </vs-td>
                        <vs-td>
                        At Sea
                        </vs-td>
                        <vs-td>
                        </vs-td>
                        <vs-td>
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td>
                            7
                        </vs-td>
                        <vs-td>
                        Vancouver
                        </vs-td>
                        <vs-td>
                        </vs-td>
                        <vs-td>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            
			</div>
			<div
				class="w-full lg:w-1/2 sm:w-1/1 pl-4 rounded"
				style="background-size: cover; background-position: center center"
				v-bind:style="{
					backgroundImage:
						'url(' +
						require('@/assets/images/alaska-map.png') +
						')',
				}"
			></div>
		</div>





	</div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  }
}
</script>
